import React from "react";
import { BibleBookNamesType } from "../../data/BibleBookNames";

interface IBibleTextVerseProps {
    book: BibleBookNamesType;
    chapter: number;
    verse: number;
    text?: string;
    openExtraOptions?: Function;
    setReference?: Function;
}

const BibleTextVerse: React.FC<IBibleTextVerseProps> = (props) => {
    return <span 
        ref={(element: HTMLSpanElement) => props.setReference && props.setReference(element)}
        id={`${props.book} ${props.chapter}:${props.verse}`}
        onClick={() => props.openExtraOptions && props.openExtraOptions(props.book, props.chapter, props.verse)}>{props.text}</span>
};

export default BibleTextVerse;